import _ from 'lodash';

import createSharedState from 'hooks/createSharedState';

const [useMintImportSharedState, getMintImportSharedState, setMintImportSharedState] = createSharedState({});
const mergeMintImportSharedState = (props) =>
  setMintImportSharedState({ ..._.merge(getMintImportSharedState(), props) });
export { useMintImportSharedState, mergeMintImportSharedState, getMintImportSharedState };
